import { createSelector } from 'reselect'

const getAttachmentDetails = (state: any) => state.attachmentDetails

/** A Redux selector to retrieve Download Count
 * @param state - The Redux state
 * @param {Boolean} - Numerical value indicating Download Count.
 */

export const selectDownloadCount = createSelector(
  getAttachmentDetails,
  (data) => data && data.downloadCount ? data.downloadCount.count : 0
)

/** A Redux selector to retrieve Attachments
 * @param state - The Redux state
 * @param {Array} - Aray value - Attachments.
 */

export const selectAttachments = createSelector(
  getAttachmentDetails,
  (data) => data && data.attachments ? data.attachments.attachments : []
)